export const GLOBAL_DATE_FORMAT = "DD MMM YYYY";
